import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Maria García',
    age: 34,
    city: 'Buenos Aires, Argentina',
    text: 'Le ricette sono facilissime. Ora i miei plumcake vengono sempre perfetti!'
  }, {
    name: 'Carmen López',
    age: 42,
    city: 'Città del Messico, Messico',
    text: 'Ho iniziato a vendere grazie al libro. Ora ho clienti fissi.'
  }, {
    name: 'Lucía Fernández',
    age: 28,
    city: 'Madrid, Spagna',
    text: 'Le spiegazioni sono chiarissime. Risultati perfetti.'
  }, {
    name: 'Ana Rodríguez',
    age: 51,
    city: 'Bogotá, Colombia',
    text: 'La guida alle conversioni mi ha salvato!'
  }, {
    name: 'Patricia Morales',
    age: 38,
    city: 'Santiago, Cile',
    text: 'I bonus valgono già il prezzo.'
  }];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-304">
      <div className="max-w-6xl mx-auto" data-id="element-305">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-306">
          ⭐ Cosa dicono i nostri clienti
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-307">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col" data-id="element-308">
              <div className="flex gap-1 mb-4" data-id="element-309">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-310" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-311">"{t.text}"</p>
              <div className="w-full h-px bg-gray-100 mb-4" data-id="element-312"></div>
              <div data-id="element-313">
                <p className="font-bold text-gray-900" data-id="element-314">
                  {t.name}, {t.age}
                </p>
                <p className="text-sm text-gray-500" data-id="element-315">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}